module.exports = __webpack_public_path__ + "static/media/caretRight-24.83913c02.svg";